import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Market from '../components/Market';
import actions from '../redux/actions/favorites';
import actionsPrice from '../redux/actions/price';

const mapStateToProps = (state) => ({
  setting: state.setting,
  coins: state.setting.coins,
  favorites: state.setting.favorites,
  currencyLightChart: state.price.currencyLightChart,
  currencyMarkets: state.setting.currencyMarkets,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUpdateFavoritesAction: (params) => {
    dispatch(actions.fetchUpdateFavoritesAction(params));
  },
  fetchDeleteFavoritesAction: (params) => {
    dispatch(actions.fetchDeleteFavoritesAction(params));
  },
  localFetchUpdateFavoritesAction: (params) => {
    dispatch(actions.localFetchUpdateFavoritesAction(params));
  },
  localFetchDeleteFavoritesAction: (params) => {
    dispatch(actions.localFetchDeleteFavoritesAction(params));
  },
  fetchPriceMarket24h: (params) => {
    dispatch(actionsPrice.fetchPriceMarket24h(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Market));
